import React from "react";
import MaskedDatePicker from "../masked-date-picker";
import { Input } from "antd";

export default function MaskedRangePicker({ value, onChange, disabled, style, className }) {
  const [start, end] = value || [null, null];

  const handleStart = (date) => {
    onChange?.([date, end]);
  };

  const handleEnd = (date) => {
    onChange?.([start, date]);
  };

  return (
    <Input.Group compact className={className} style={{ display: "flex", ...style }}>
      <MaskedDatePicker placeholder="Início" value={start} onChange={handleStart} disabled={disabled} />
      <MaskedDatePicker placeholder="Fim" value={end} onChange={handleEnd} disabled={disabled} />
    </Input.Group>
  );
}
